<template>
    <div class="container-fluid">
        <h4 class="bg-secondary text-white text-center p-2">Subnetting Redes Simétricas</h4>
        <div class="form-group">
            <label>Dirección Red:</label>
            <input type="text" class="form-control" v-model="netaddress">
        </div>
        <div class="form-group">
            <label>Máscara (CIDR):</label>
            <input type="text" class="form-control" v-model="netmaskcidr">
        </div>
        <div class="form-group">
            <label>Número de subredes:</label>
            <input type="text" class="form-control" v-model="subnets">
        </div>
        <simmetrical-subnetting :initialnetaddress=netaddress :initialnetmaskcidr=netmaskcidr :subnets=subnets></simmetrical-subnetting>
    </div>
</template>

<script>

import SimmetricalSubnetting from "./SimmetricalSubnetting";

export default {
    data: function () {
        return {
            netaddress: '',
            netmaskcidr: 0,
            subnets: 0,
        }
    },
    components: {'simmetrical-subnetting': SimmetricalSubnetting }
}
</script>